import { render, staticRenderFns } from "./CollectionFilters.vue?vue&type=template&id=497c06be&scoped=true"
import script from "./CollectionFilters.vue?vue&type=script&lang=js"
export * from "./CollectionFilters.vue?vue&type=script&lang=js"
import style0 from "./CollectionFilters.vue?vue&type=style&index=0&id=497c06be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c06be",
  null
  
)

export default component.exports